<template>
  <i :class="`iconfont icon-${name}`" :style="iconStyle"></i>
</template>

<script lang="ts">
import { computed } from 'vue';

export default {
  name: 'IconFont',
  props: {
    name: {
      type: String,
      required: true,
    },
    size: {
      type: [String, Number],
      default: 'inherit',
    },
    color: {
      type: String,
      default: 'inherit',
    },
  },
  setup(props) {
    // 计算图标样式
    const iconStyle = computed(() => ({
      fontSize: typeof props.size === 'number' ? `${props.size}px` : props.size,
      color: props.color,
    }));

    return {
      iconStyle,
    };
  },
};
</script>

<style scoped>
.iconfont {
  display: inline-flex;
  align-items: center;
  font-style: normal;
}
</style>
